<template>
  <div class="content">
    <img :src="require(`@/../public/automa/logo.png`)" />
    <div class="line">
      <div class="l1"></div>
      <div class="l2"></div>
      <div class="l3"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.content {
  padding-top: 3px;
  display: inline-grid;
  width: 100%;
}
.line {
  display: grid;
  grid-template-columns: auto auto auto;
  width: 100%;
  height: 5px;
}
.l1 {
  background: #4d89a7;
  animation-duration: 2.5s;
  animation-name: loading;
}
.l2 {
  background: #99bbcd;
  animation-duration: 2.5s;
  animation-name: loading;
}
.l3 {
  background: #ccdde6;
  animation-duration: 2.5s;
  animation-name: loading;
}
@keyframes loading {
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
}
img {
  margin: auto;
  max-width: 105px;
  margin-bottom: 4px;
  margin-top: 4px;
}
</style>